import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fadeAndSlideUp } from '@smartera/animations';
import { UtilityService } from '@core/services/utility.service';

import { BaseComponent } from '@modules/components/base-component';
import { SISTEK_EMAIL_PATTERN } from '@modules/validators/patterns';
import { RegistrationService } from './services/registration.service';

@Component({
	selector: 'app-registration',
	templateUrl: './registration.component.html',
	styleUrls: ['./registration.component.scss'],
	animations: [fadeAndSlideUp],
	standalone: false,
})
export class RegistrationComponent extends BaseComponent implements OnInit {
	public form: FormGroup;
	public isNotRobot = false;
	public display: boolean = false;

	constructor(
		private _registrationService: RegistrationService,
		private _router: Router,
		utilServ: UtilityService
	) {
		super(null, utilServ);
		this.form = this.builder.group({
			email: ['', [Validators.email, Validators.required, Validators.pattern(SISTEK_EMAIL_PATTERN)]],
			lastname: ['', [Validators.required, Validators.maxLength(100)]],
			name: ['', [Validators.required, Validators.maxLength(100)]],
			phone: [null, [Validators.maxLength(16)]],
			privacyPolicy: [false, [Validators.requiredTrue]],
			status: ['NEW'],
		});
	}

	public ngOnInit(): void {
		this.hideloader();
	}

	public dialogStatus(): void {
		this.display = true;
	}

	public registration(): void {
		if (this.form.valid) {
			this.showLoader();
			this._registrationService.createNewUser(this.form.value).subscribe(() => {
				this.hideloader();
				this.dialogStatus();
				this.utilServ.alertService.success(this.t('alert.title.success'), this.t('registration.successMessage'));
			});
			this.hideloader();
		}
	}

	onHideEvent(): void {
		this._router.navigateByUrl('/login');
	}
}
